import axios from '@/http'

// 教培-获取用户信息
export function jpGetUserInfo(data) {
    return axios({
        url: '/api/jp/get-user-info',
        method: 'POST',
        data
    })
}

// 教培-获取关联账号列表
export function jpGetUserList(data) {
    return axios({
        url: '/api/jp/get-user-list',
        method: 'POST',
        data
    })
}


// 教培-添加帐号关联
export function jpAddGetRelation(data) {
    return axios({
        url: '/api/jp/add-user-relation',
        method: 'POST',
        data
    })
}

// 教培-切换帐号登录
export function changeUserLogin(data) {
    return axios({
        url: '/api/jp/change-user-login',
        method: 'POST',
        data
    })
}


// 教培-移除帐号关联
export function jpDelGetRelation(data) {
    return axios({
        url: '/api/jp/del-user-relation',
        method: 'POST',
        data
    })
}

// 首次登录
export function isFirstLogin(data) {
    return axios({
        url: '/api/jp/is-first-login',
        method: 'POST',
        data
    })
}


// 修改用户信息
export function updateUserInfo(data) {
    return axios({
        url: '/api/jp/update-user-info',
        method: 'POST',
        data
    })
}


// 老师端-获取班级信息
export function jpGetClass(data) {
    return axios({
        url: '/api/jp-class/get-class',
        method: 'GET',
        params: data
    })
}


// 学生端-获取班级信息
export function jpStuGetClass() {
    return axios({
        url: '/api/student-order/get-class',
        method: 'GET',
    })
}
// 教培-检测词汇是否禁用
export function isBadWord(data) {
    return axios({
        url: '/api/bad-key-word/is-bad-word',
        method: 'GET',
        params: data
    })
}
// 教培--更新用户昵称
export function updateUserName(data) {
    return axios({
        url: '/api/jp/update-user-real-name',
        method: 'POST',
        data
    })
}